import { LocationContact } from '@hakimo-ui/hakimo/types';

export const ADD_CONTACT_ID_PREFIX = 'contact-add-';

const PHONE_NUMBER_PATTERN =
  /^[0-9]{3,4}$|^(\+[0-9]+)?[\s-]?[0-9]{3}[\s-]?[0-9]{3}[\s-]?[0-9]{4}$|^(\+[0-9]+)?\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/;

export const getColumns = () => {
  return [
    {
      id: 'priority',
      name: 'Priority',
    },
    {
      id: 'name',
      name: 'Name',
    },
    {
      id: 'phoneNumber',
      name: 'Phone Number',
    },
    {
      id: 'email',
      name: 'Email',
    },
    { id: 'tag', name: 'Tag' },
    {
      id: 'action',
      name: 'Actions',
    },
  ];
};

function isValidPhoneNumber(phoneNumber: string): boolean {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return true;
  }
  return PHONE_NUMBER_PATTERN.test(phoneNumber);
}

export function validateValues(contact: LocationContact) {
  let message = '';
  if (contact.name === '') {
    message = 'Contact name should be provided';
  } else if (contact.tag === '') {
    message = 'Contact tag should be provided';
  } else if (!isValidPhoneNumber(contact.phoneNumber || '')) {
    message = 'Phone number format is invalid';
  }

  return { isValid: !message, message };
}
